export { default } from './part-page-banner';
